import Vue from 'vue';
import { prefix_m } from 'src/constant.js';
import Component from 'vue-class-component';


import 'bootstrap/dist/css/bootstrap.css';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })


@Component
export default class Info extends Vue{
    
    constructor() {
        super();
        this.container = null;
    }
    created(){
        this.container = this.$attrs.container;
    }
    mounted(){
        
    }
    render (h) {
		return(
            <div>
                <link href={/*prefix_m+*/"/assets/font/open-iconic/font/css/open-iconic.css"} rel="stylesheet"/>

                <nav class="navbar navbar-inverse bg-inverse">
                    <div>
                        <div class="navbar-brand" href="" style="outline: 0;">
                        <router-link to="/report" ><span class = "navbar-brand">Отчет о списаниях</span></router-link> </div>
                        <div class="navbar-brand" href="" style="outline: 0;">
                            <router-link to="/view_emp" >
                                <span class = "navbar-brand">Информация о сотрудниках </span>
                            </router-link>  
                        </div>
                    </div>
                    <div class="navbar-toggler-right">
                        <div class="navbar-brand align-top" style="font-size: 11pt; display: inline-block" href="">{this.container.getFullName()}</div>
                        <router-link to="/logout"> 
                            <span 
                                class="oi align-middle align-text-bottom exit mr-3" style="font-size: 23pt;  display: inline-block" data-glyph="account-logout" 
                            ></span>
                        </router-link>  
                    </div>
                </nav>
                <div class="table-borders my-3">
                    <table class="table table-bordered table-sm" style="font-size: 10pt;">
                        <thead >
                            <tr>
                                <th style="background-color: #e4e4e4;" rowspan="1" colspan="1" >Фамилия</th>
                                <th style="background-color: #e4e4e4;" rowspan="1" colspan="1" >Телефон</th>
                            </tr>
                            
                        </thead>
                        <tbody>
                            {/* справочник о сотрудниках */}
                            {Array.from({ length: this.container.getInfo().length },
                                (v, k) => k+1).map((i) => (
                                    <tr>

                                            <td class = "text-left">

                                                {this.container.getInfo()[i-1].fullname}

                                            </td>

                                            <td class = "text-center">

                                                {this.container.getInfo()[i-1].phone}

                                            </td>
                                        
                                    </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <style jsx>{`
                    .table-borders {
                        padding-left: 200px;
                        padding-right: 200px;
                    }
                        
                    .exit{
                        font-size: 25pt; 
                        color:#ffffff; 
                        :hover{
                            color: #e4e4e4;
                        }
                    }
                    span:hover{
                            color: #a2a2a2;
                    }
                    th{
                        background-color: #e8f4ff7d;
                        text-align: center;
                    }
                    td{
                        text-align: center;
                    }

                    
                `}</style>
            </div>
                

            );
        }
    }




// WEBPACK FOOTER //
// ./src/Info/Info.js